import {view} from '@sail/ui/deprecated';
import {ConversationLogItemMetaEvent} from '@stripe-internal/conversations-client';
import {FormattedMessage} from 'react-intl';
import {MetaRow} from '../../Chat';

export const MetaEventRow = ({item}: {item: ConversationLogItemMetaEvent}) => {
  return (
    <view.div
      data-testid="conversation-meta-event"
      className="uh-conversations-contains-meta-row"
    >
      <MetaRow style={item.style}>
        <FormattedMessage {...item.message} values={item.values} />
      </MetaRow>
    </view.div>
  );
};
